import React from 'react'
import Header from '../../Components/Header/header';
import ImageSlider from '../../Components/ImageSlider/imageSlider';
import Reach from '../../Components/Reach/reach';
import FootPage from '../../Components/FooterPage/footPage';
import './signup.css';

export default function Login() {

  const [message, setMessage] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    isFriendly: false

    
})

function handleChange(event) {
  const {name, value, type, checked} = event.target
  setMessage(prevState => {
    return {
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }
  })

}
  return (
    <div className='login'>
       <Header />
      <div className='login-input2'>
        <div className="login-left2">
          <h4 className="login-title1">Sign In</h4>
          <p className='login-description'>Proin facilisis varius nunc. Curabitur eros risus, ultrices et dui ut, luctus accumsan nibh. Fusce convallis sapien placerat tellus suscipit vehicula.fermentum. Curabitur pellentesque</p>
          <div className='login-ask2'>
            <p className='login-acct1'>Already have an account?</p>
            <p className='login-acct3'><a href="/login" className='login-link'>Sign In</a></p>
          </div>
        </div>
      <div className='login-right2'>
      <form action='/action_page.php'>
      <label for='firstName'>First name</label>
       <input
        type='text'
        placeholder= 'First name'
        className='form-input-login'
        name='fullname'
        value={message.firstName}
        onChange={handleChange}
      />
      <span className="sub-input">First name is required</span>
      
      <label for='lastName'>Last name</label>
       <input
        type='text'
        placeholder= 'Last name'
        className='form-input-login'
        name='fullname'
        value={message.lastName}
        onChange={handleChange}
      />
      <span className="sub-input">Last name is required</span>
      
        <label for='email'>Email</label>
       <input
        type='text'
        placeholder= 'Email'
        className='form-input-login'
        name='fullname'
        value={message.email}
        onChange={handleChange}
      />
      <span className="sub-input">Email is required</span>
      
         <label for='password'>Password</label>
       <input
        type='password'
        placeholder='password'
        className='form-input-login'
        name='email'
        value={message.password}
        onChange={handleChange}
      />
      <span className="sub-input">Password is required</span>
      
      <label for='password'>Confirm Password</label>
       <input
        type='password'
        placeholder='password'
        className='form-input-login'
        name='email'
        value={message.confirmPassword}
        onChange={handleChange}
      />
      <span className="sub-input2">Password must be 8 characters or more and must contain upper case alphabet, lower case alphabet, characters and numbers.</span>
      
       <input
       type='submit' 
       className='form-button-login' 
       value='CREATE ACCOUNT'
       />
       <input
       type='checkbox' 
       id="isFriendly"
       checked={message.isFriendly}
       onChange={handleChange}
       name='isFriendly'
       />
       
       <label htmlFor='isFriendly'>Remember me</label>
       
       </form>
       <a href="#" className='forgot'>Forgot Password?</a>
      </div>

      </div>
      <div className="slider-login">
        <ImageSlider />
        </div>
        <Reach />
        <div className="footPage">
          <FootPage />
        </div>
    </div>
  )
}
